import countriesMap from '../dicts/countries';

export function mapCountry(option) {
  const validOption = option || {};

  return {
    ...validOption,
    countryCode: validOption.country,
    country: countriesMap[validOption.country],
  };
}

export function remapCountry(option) {
  const validOption = option || {};

  return {
    ...validOption,
    country: validOption.countryCode,
  };
}

export default function getSuggestOptions(data) {
  if (Array.isArray(data)) {
    return data;
  }

  if (
    data &&
    data.id &&
    data.name &&
    !countriesMap[data.country] &&
    countriesMap[data.countryCode]
  ) {
    return [{ ...data }];
  }

  if (data && data.id && data.name && countriesMap[data.country]) {
    return [{ ...mapCountry(data) }];
  }

  return null;
}
